/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_ClearInputs */

const en_ui_weather_clear = /** @type {(inputs: Ui_Weather_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const de_ui_weather_clear = /** @type {(inputs: Ui_Weather_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Ui_Weather_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_clear = /** @type {((inputs?: Ui_Weather_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_clear(inputs)
	return de_ui_weather_clear(inputs)
});